import ApiClient from '@/services/api-client'
import Vue from 'vue'
import { ACCOUNT_PROFILE_ADMIN, ACCOUNT_PROFILE_MANAGER, ACCOUNT_PROFILE_USER } from '@/utils/constants'

export class AccountUtils {
  static profiles: string[] = []
  static pendingRequest: Promise<void> | null = null

  public static async getProfiles(): Promise<string[]> {
    await this.loadProfiles()
    return this.profiles
  }

  public static getRoleVariant(role: string): string {
    switch ((role || '').toUpperCase()) {
      case 'ADMIN': return 'dark'
      case 'ACCESS': return 'info'
      case 'EDITOR': return 'success'
      case 'SPECIAL': return 'warning'
      case 'READ': return 'secondary'
      default: return 'info'
    }
  }

  public static getProfileTranslationKey(profile: string | undefined): string {
    if (!profile) return 'account_detail.profiles.user'

    switch (profile.toUpperCase()) {
      case ACCOUNT_PROFILE_ADMIN:
        return 'account_detail.profiles.admin'
      case ACCOUNT_PROFILE_MANAGER:
        return 'account_detail.profiles.manager'
      case ACCOUNT_PROFILE_USER:
        return 'account_detail.profiles.user'
      default:
        return profile
    }
  }

  public static getProfilesForSelect(isAdmin: boolean): Array<{ value: string; labelKey: string }> {
    const allProfiles = [
      { value: ACCOUNT_PROFILE_ADMIN, labelKey: this.getProfileTranslationKey(ACCOUNT_PROFILE_ADMIN) },
      { value: ACCOUNT_PROFILE_MANAGER, labelKey: this.getProfileTranslationKey(ACCOUNT_PROFILE_MANAGER) },
      { value: ACCOUNT_PROFILE_USER, labelKey: this.getProfileTranslationKey(ACCOUNT_PROFILE_USER) }
    ]

    if (isAdmin) {
      return allProfiles
    }

    return allProfiles.filter(p => p.value !== ACCOUNT_PROFILE_ADMIN)
  }

  private static async loadProfiles() {
    if (this.profiles.length > 0) {
      return
    }

    if (!this.pendingRequest) {
      this.pendingRequest = (async() => {
        try {
          const response = await ApiClient.getAccountProfiles()
          Vue.set(this, 'profiles', response)
        } finally {
          this.pendingRequest = null
        }
      })()
    }

    await this.pendingRequest
  }
}
